import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetUser {
    getUser {
      id
      org_id
      identifier
      survey_responses
      user_preferences
    }
  }
`;
